import { combineReducers } from 'redux';
import {
  PERFORM_LOGOUT,
  UPDATE_USER
} from 'constants/actions.js';
import update from 'immutability-helper';

const session = (session = {}, action) => {
  switch(action.type) {
    case UPDATE_USER:
      return { ...session,  ... action.session  }
    case PERFORM_LOGOUT:
      return {}
    default: return session;
  }
}

export { session };



// WEBPACK FOOTER //
// ./src/reducers/session.js